import React, { ReactNode } from 'react';
import { Accordion, Typography } from '@mui/material';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AccordionDetails from '@mui/material/AccordionDetails';
import {
  accordion,
  accordionSummary,
  accordionDetails,
} from 'app/pages/anipay/new-payment/ui/accordion-wrap/accordion-wrap.sx';

interface Props {
  title: string;
  children: ReactNode;
}
const AccordionWrap = (props: Props) => {
  const { children, title } = props;

  return (
    <Accordion expanded={true} sx={accordion}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls='panel1-content'
        id='panel1-header'
        sx={accordionSummary}
      >
        <Typography
          sx={{
            fontSize: '20px',
            fontWeight: 600,
          }}
        >
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={accordionDetails}>{children}</AccordionDetails>
    </Accordion>
  );
};

export default AccordionWrap;
